// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal .ant-modal-title {
  font-size: 18px !important;
  margin-bottom: 20px;
}

.ant-input {
  font-size: 15px !important;
}

.timepickers {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.ant-btn {
  font-size: 15px !important;
  height: 40px !important;
}

.slot_card {
  padding: 64px;
}

.ant-picker-calendar-header {
  margin-bottom: 20px !important;
}

.calendar_card {
  border-radius: 16px;
  border: 1px solid #dad7d7;
}

.ant-picker-calendar {
  border-radius: 16px;
  padding: 8px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TimeSlots/timeslots.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".ant-modal .ant-modal-title {\n  font-size: 18px !important;\n  margin-bottom: 20px;\n}\n\n.ant-input {\n  font-size: 15px !important;\n}\n\n.timepickers {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.ant-btn {\n  font-size: 15px !important;\n  height: 40px !important;\n}\n\n.slot_card {\n  padding: 64px;\n}\n\n.ant-picker-calendar-header {\n  margin-bottom: 20px !important;\n}\n\n.calendar_card {\n  border-radius: 16px;\n  border: 1px solid #dad7d7;\n}\n\n.ant-picker-calendar {\n  border-radius: 16px;\n  padding: 8px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
